import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    urls: Array,
    currentIndex: Number
  }

  static targets = [
    "startDate",
    "endDate",
    "classes",
    "attendances",
    "aca",
    "stockSales",
    "trials",
    "activations",
    "kyuGrading",
    "progressWrapper",
    "progressBar",
    "status",
    "applyBtn"
  ]

  connect() {
    console.log("dojo controller loaded...")
  }

  apply() {
    this.currentIndexValue = 0

    this.statusTarget.classList.remove("hidden")
    this.progressWrapperTarget.classList.remove("hidden")
    this.applyBtnTarget.disabled = true

    this.loadNextBatch()
  }

  async loadNextBatch() {
    if (this.currentIndexValue >= this.urlsValue.length) {
      this.finish()
      return
    }

    const currentUrl = this.urlsValue[this.currentIndexValue] + "&[statistics]start_date=" + this.startDateTarget.value + "&[statistics]end_date=" + this.endDateTarget.value

    this.updateUI("loading")

    try {
      const response = await fetch(currentUrl, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Accept": "text/html"
        }
      })

      if (!response.ok) throw new Error(`Server returned ${response.status}`)

      const data = await response.text()
      const payload = data.split(";")

      switch (payload[0]) {
        case "classes":
          this.classesTarget.innerHTML = payload[1]
          break
        case "attendances":
          this.attendancesTarget.innerHTML = payload[1]
          break
        case "aca":
          this.acaTarget.innerHTML = payload[1]
          break
        case "stock_sales":
          this.stockSalesTarget.innerHTML = payload[1]
          break
        case "trials":
          this.trialsTarget.innerHTML = payload[1]
          break
        case "activations":
          this.activationsTarget.innerHTML = payload[1]
          break
        case "kyu_grading":
          this.kyuGradingTarget.innerHTML = payload[1]
          break
      }

      this.currentIndexValue++
      this.loadNextBatch()

    } catch (error) {
      console.error("Sequential load failed:", error)
      this.updateUI("error")
    }
  }

  updateUI(state) {
    const total = this.urlsValue.length
    const current = this.currentIndexValue + 1
    const percent = Math.min((current / total) * 100, 100)

    if (this.hasStatusTarget) {
      if (state === "error") {
        this.statusTarget.innerText = "Error loading data."
      } else {
        this.statusTarget.innerText = `Processing Dojo statistics ${current} of ${total}...`
      }
    }

    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${percent}%`
    }
  }

  finish() {
    // cleanup
    this.statusTarget.classList.add("hidden")
    this.progressWrapperTarget.classList.add("hidden")
    this.applyBtnTarget.disabled = false

    this.dispatch("completed")
  }
}
